export const residences = [
  { value: 'Própria com encargos', label: 'Própria com encargos' },
  { value: 'Própria sem encargos', label: 'Própria sem encargos' },
  { value: 'Alugada', label: 'Alugada' },
  { value: 'Profissional', label: 'Profissional' },
  { value: 'Outra', label: 'Outra' },
  { value: 'Família', label: 'Família' },
]
